import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";

interface SearchToolProps {
  isActive: boolean;
  onClick: () => void;
}

/**
 * A simple presentational component that renders the search toggle button.
 * All search logic is handled by the parent component.
 */
export function SearchTool({ isActive, onClick }: SearchToolProps) {
  return (
    <IconButton
      aria-label="search-logs"
      disableFocusRipple
      onClick={onClick}
      size="small"
      title="Search logs"
    >
      <SearchIcon color={isActive ? "primary" : "inherit"} fontSize="small" />
    </IconButton>
  );
}
